import styled from 'styled-components';
import { SectionParent } from '../../StyledComponents';

import React from 'react';
import RequestDemoForm from './RequestDemoForm';

const SectionTwo = styled(SectionParent)`
  background-repeat: no-repeat;
  background: #fafbfe;
  /* padding-top: 6rem !important; */
  padding-bottom: 5rem;
  min-height: 486px;
  margin-top: 6rem !important;
  padding-top: 5rem !important;
  text-align: center;
  align-content: center;
  background-size: contain;
  width: 100%;
  display: grid;
  grid-template-columns: auto auto;
  @media (max-width: 1680px) and (min-width: 768px) {
    padding-bottom: 5rem;
  }
  @media (max-width: 768px) {
    padding-top: 8rem !important;
    grid-template-columns: auto;
  }
  @media (max-width: 520px) {
    padding-top: 2rem !important;
    padding-bottom: 5rem !important;
  }
`;

const Item = styled.div`
  display: grid;
  align-items: center;
  margin-left: 25%;
  @media (max-width: 768px) {
    margin-left: 0%;
  }
`;

const ItemContainer = styled.div`
  display: grid;
  align-content: center;
  grid-gap: 58px 0rem;
`;

const ItemContent = styled.div`
  @media (max-width: 768px) {
    display: grid;
  }
`;
const ItemContentMobile = styled.div`
  @media (max-width: 768px) {
    display: none;
  }
`;

const ItemTitle = styled.div`
  font-size: 32px;
  font-weight: 500;
  text-align: left;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #2d2b33;
  @media (max-width: 768px) {
    text-align: center;
  }
`;

const ItemDescription = styled.div`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  margin-top: 4px;
  font-weight: normal;
  text-align: left;
  max-width: 343px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #26315c;
  @media (max-width: 768px) {
    text-align: center;
    justify-self: center;
  }
`;

const ItemDescriptionL = styled.a`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  margin-top: 4px;
  font-weight: normal;
  text-align: left;
  float: left;
  max-width: 343px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #26315c;
  @media (max-width: 768px) {
    text-align: center;
    justify-self: center;
  }
`;

export default class BookDemoSectionOne extends React.Component<any, any> {
  render() {
    return (
      <div style={{ position: 'relative' }}>
        <SectionTwo id="section-one-kiosk">
          <ItemContainer>
            <Item>
              <ItemContent>
                <ItemTitle>
                  {this.props.messages?.ContactUsPageTitle1}
                </ItemTitle>
                <ItemDescription>
                  {this.props.messages?.ContactUsPageDesc1}
                </ItemDescription>
              </ItemContent>
            </Item>
            <Item>
              <ItemContentMobile>
                <ItemTitle>
                  {this.props.messages?.ContactUsPageTitle2}
                </ItemTitle>
                <ItemDescription>
                  Esper
                  <br />
                  3600 136th Pl SE # 220,
                  <br />
                  Bellevue, WA 98006
                </ItemDescription>
              </ItemContentMobile>
            </Item>
            <Item>
              <ItemContentMobile>
                <ItemTitle>
                  {this.props.messages?.ContactUsPageTitle3}
                </ItemTitle>
                <ItemDescriptionL href="mailto:support@esper.io">
                  support@esper.io
                </ItemDescriptionL>
              </ItemContentMobile>
            </Item>
          </ItemContainer>
          <RequestDemoForm
            messages={this.props.messages}
            endState={`/contact-us/submitted`}
          />
        </SectionTwo>
      </div>
    );
  }
}
